export const ACTION_PREFIX = 'MOBILE_VERIFICATION';

export const actionTypes = {
  LOGIN_CODE_SENT: 'LOGIN_CODE_SENT',
  UPDATE_LOGIN_CODE_SENDING_FAILURE: 'UPDATE_LOGIN_CODE_SENDING_FAILURE',
  UPDATE_MOBILE_VALIDATION_RESULT: 'UPDATE_MOBILE_VALIDATION_RESULT',
  RESET_VALIDATION: 'RESET_VALIDATION',
  UPDATE_CAN_RESEND_LOGIN_CODE: 'UPDATE_CAN_RESEND_LOGIN_CODE',
  RESET: 'RESET',
};
